type ValueOf<T> = T[keyof T];

export const sessionStorageKeys = {
  ADMIN_USER_SELECTED_CHAIN: 'admin-user-selected-chain',
} as const;

export const sessionStorageUtil = {
  setItem<T>(key: ValueOf<typeof sessionStorageKeys>, value: T): void {
    if (value === undefined || value === null) {
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  getItem<T>(key: ValueOf<typeof sessionStorageKeys>): T | null {
    const item = sessionStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item) as T;
    } catch (e) {
      return null;
    }
  },

  removeItem(key: ValueOf<typeof sessionStorageKeys>): void {
    sessionStorage.removeItem(key);
  },

  clear(): void {
    sessionStorage.clear();
  },
};
